<template>
  <div class="container-fluid p-3">
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="card">
          <div class="card-header">
            <h5>PARTE</h5>
          </div> 
          <div class="card-body">
            <div class="alert alert-light">
              <i class="fa fa-exclamation"></i> Realice los siguientes pasos para el registro masivo a través de la plantilla Excel. <a class="btn-link" @click="onPopupAyuda" >Ver ejemplo de plantilla Excel.</a><br><br>
              <b>Declaración sin movimiento</b> cuando no registra: Ingreso, Salida, Permanente en tipo detalle.
            </div>
            <hr>
            <h6>PASO 1: <small><b>DESCARGAR ARCHIVO EXCEL</b></small></h6>
            <div class="row">
              <div class="col-md-12 text-center mt-2">
                <button type="button" class="btn btn-outline-success" @click="downloadPlantilla">
                  <i class="fa fa-download"></i> Descargar Plantilla
                </button>
              </div>
            </div><br>
            <div class="alert alert-warning" role="alert" style="background-color:#F96540;color:#000;">
              <i class="fa fa-exclamation-triangle"></i> <b>Atención</b><br> 
              Formato oficial del Excel<br><b>Solo utilizar la plantilla de descarga.</b>
            </div>
            <hr>
            <h6>PASO 2: <small><b>SUBIR ARCHIVO EXCEL</b></small></h6>
            <div class="row form-group pt-3" v-if="SMovimiento">
              <div class="col-12 col-md-12">
                <label class="mr-1">Cargar archivo:</label> 
                <input 
                  type="file" 
                  id="file" 
                  ref="file" 
                  class="form-control" 
                  accept=".xls,.xlsx"
                  @change="actualizaExcel($event)" 
                >
              </div>
            </div>
            <div class="row form-group">
              <div class="col-12 col-md-12">
                Declaración sin movimiento: 
                <input
                  type="checkbox"
                  v-model="sin_movimiento"
                  true-value="S/M"
                  false-value=""
                  @change="onChangeSinMovimiento()"
                >
              </div>
            </div>
            <div class="row form-group">
              <div class="col-12 col-md-12">
                <label>Parte de fecha:</label>
                {{getDate(fechas.ayer)}}
                <b>al</b>
                {{getDate(fechas.actual)}}
              </div>
            </div>  
            
            <hr>
            <div class="row">
              <div class="col-12 col-md-12 text-right">
                <button type="button" class="btn btn-primary" @click="procesarArchivo">Registrar Parte</button>
              </div>
            </div>
          </div>
            
        </div>
      </div>
      <div class="col-12 col-md-8">
        <div class="card">      
          <div class="card-header">
            <h5>{{'EMPRESA - ' + empresa.emp_razon_social}}</h5>
          </div>        
          <div class="card-body">
            <div class="alert alert-warning" role="alert" style="background-color: rgba(248, 214, 43, 0.3);color:#000;">
              <i class="fa fa-exclamation-triangle"></i> <b>Atención</b><br> 
              Debe finalizar los partes declarados, si los datos cargados son correctos.<br>
              Parte en estado <b>pendiente</b> tiene hasta 48 hrs para realizar el <b>alta</b> o <b>baja</b>, después de la fecha de registro. Una vez vencido no se tomar en cuenta como una declaración formal.
            </div>
            <p><small><strong>HISTORIAL DE MANIFIESTO</strong></small></p>
            <div class="table-responsive" style="overflow-y:scroll; height:360px;">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th class="text-center"><small class="font-weight-bold">NRO</small></th>
                    <th class="text-center"><small class="font-weight-bold">FECHAS</small></th>
                    <th class="text-center"><small class="font-weight-bold">TOTAL REGISTRO</small></th>
                    <th class="text-center"><small class="font-weight-bold">FECHA REGISTRO</small></th>
                    <th class="text-center"><small class="font-weight-bold">ESTADO</small></th>
                    <th class="text-center"><small class="font-weight-bold">ACCIONES</small></th>
                  </tr>                        
                </thead>
                <tbody>
                  <tr v-for="(item, index) in historial" :key="index">
                    <td class="text-center"><small>{{index+1}}</small></td>
                    <td class="text-center"><small>{{'DE ' + getDate(item.fecha_inicio)}}<br>AL {{ getDate(item.fecha_fin)}}</small></td>
                    <td class="text-center">
                      <small v-if="item.observacion=='S/M'">DECLARACIÓN<br>SIN MOVIMIENTO</small>
                      <small v-else>{{item.total_registros}}</small>
                    </td>
                    <td class="text-center"><small>{{getDateTime(item.fecha_reg)}}</small></td>
                    <td class="text-center">
                      <span v-if="item.estado_proceso == 0 && item.verifica_estado == 1" class="badge badge-warning">PENDIENTE</span>
                      <span v-if="item.estado_proceso == 0 && item.verifica_estado == 0" class="badge badge-danger">VENCIDO</span>
                      <span v-if="item.estado_proceso == 1" class="badge badge-success">FINALIZADO</span>
                    </td>
                    <td class="text-center">
                      <a 
                        v-if="item.estado_proceso == 0 && item.verifica_estado == 1" 
                        class="btn btn-outline-success btn-sm mr-1" 
                        title="Alta de Parte"
                        @click="showModalConfirmar(item)"
                      >
                        <i class="fa fa-check"></i>
                      </a>
                      <a 
                        v-if="item.observacion!='S/M'"
                        class="btn btn-outline-primary btn-sm mr-1" 
                        title="Ver Parte"
                        @click="showModal(item)"
                      >
                        <i class="fa fa-search"></i>
                      </a>
                      <a 
                        v-if="item.estado_proceso == 0 && item.verifica_estado == 1" 
                        class="btn btn-outline-danger btn-sm" 
                        title="Baja de Parte"
                        @click="bajaParte(item.id_hotel)"
                      >
                        <i class="fa fa-close"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
                
              </table>
            </div>  
          </div>                
        </div>
      </div>
    </div>

    <b-modal
      class="modal fade"
      hide-footer
      title="CONFIRMAR"
      ref="modalConfirmar"
      :no-close-on-backdrop="true"
    >
      <div class="container mb-3">
        <div class="row mb-1">   
          <p>¿Desea confirmar y finalizar el parte declarado?</p> 
          <p>Tome en cuenta que <strong>parte finalizado</strong>, no se podra modificar ni borrar.</p>                          
        </div>
        <div class="row float-right">
          <a class="btn btn-outline-primary mr-3" @click="confirmar(elegido)"><i class="fa fa-check"></i> Confirmar</a>
          <a class="btn btn-outline-secondary" @click="hideModalConfirmar">Cerrar</a>
        </div>
      </div>
    </b-modal>

    <b-modal
      class="modal fade"
      size="xl"
      hide-footer
      title="DETALLE DE PARTE"
      ref="modalDetalles"
      :no-close-on-backdrop="true"
    >
      <div class="container mb-3">
        <div class="row mb-1">   
          <p>Detalle de parte registrado en fecha: {{ getDateTime(elegido.fecha_reg) }}.</p>
          
          <div class="table-responsive" style="overflow-y:scroll; height:360px;" v-if="detalles.length>0">
            <table class="table table-striped table-bordered">
              <thead>
                  <tr class="text-center">
                    <th><small class="font-weight-bold">NRO.</small></th>
                    <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                    <th><small class="font-weight-bold">FECHA NACIMIENTO</small></th>
                    <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                    <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                    <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
                  </tr>                        
              </thead>
              <tbody>
                <tr v-for="(item, index) in detalles" :key="index">
                  <td class="text-center"><small>{{index+1}}</small></td>
                  <td><small>{{item.nombre_completo}}</small></td>
                  <td class="text-center"><small>{{item.fecha_nacimiento}}</small></td> 
                  <td class="text-center"><small>{{item.nro_documento}}</small></td>
                  <td class="text-center"><small>{{item.nacionalidad}}</small></td>                     
                  <td class="text-center"><small>{{item.fecha_reg}}</small></td>
                </tr>
              </tbody>
            </table>
          </div>              
        </div>
        <div class="row float-right">
          <a class="btn btn-outline-secondary" @click="hideModal">Cerrar</a>
        </div>
      </div>
    </b-modal>

    <b-modal
      class="modal fade"
      hide-footer
      title="EJEMPLO DE PLANTILLA EXCEL"
      ref="modalAyuda"
      size="xl"
      :no-close-on-backdrop="true"
    >
      <div class="container mb-3">
        <div class="row">   
          <div class="col-12 col-md-12">
            <img src="../../assets/plantilla_hotel.png" width="100%">
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 col-md-12">
            <p>Forma correcta de llenado de datos de la plantilla Excel:<br />
              - Mantener las cabeceras de cada columna.<br/>
              - Llenar los campos correspondiente a cada cabecera.
            </p>
          </div>
        </div>
        
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import FileSaver from 'file-saver';

export default {
  name: "partesHospedaje",
  data() {
    return {
      id_empresa : 0,
      tipo_vuelo: '',
      nro_vuelo: '',
      historial: [],
      detalles: [],
      elegido: {},
      empresa: {},
      fechaMin: new moment().format("YYYY-MM-DD"),
      fechas: {
        actual: '',
        ayer: ''
      },
      sin_movimiento: '',
      SMovimiento: true,

    };
  },
  methods: {
    getDate: function(fecha) {
      if(fecha != ''){
        return moment(fecha).format("DD/MM/YYYY");
      }
      return '';
    },
    getDateTime: function(fecha) {
      if(fecha != ''){
        return moment(fecha).format("DD/MM/YYYY HH:mm:ss");
      }
      return '';
    },
    showModal(item) {
      this.elegido = item;
      this.detallePartes(item.id_hotel);
      this.$refs["modalDetalles"].show();
    },
    hideModal() {
      this.elegido = {};
      this.$refs["modalDetalles"].hide();
    },
    showModalConfirmar(item) {
      this.elegido = item;
      this.$refs["modalConfirmar"].show();
    },
    hideModalConfirmar() {
      this.elegido = {};
      this.$refs["modalConfirmar"].hide();
    },
    actualizaExcel(){
      this.file = this.$refs.file.files[0];
    },
    async procesarArchivo() {
      try{
        // Verifica parte
        let res = await this.axios.get(`/verificaParteHospedaje/${this.id_empresa}/${this.fechas.actual}`);

        if(!res.data.contenido){
          this.$swal({
            title: 'Información',
            text: `El parte diario del ${this.getDate(this.fechas.actual)} al ${this.getDate(this.fechas.ayer)} para la empresa: ${this.empresa.emp_razon_social}, ya fue registrado.`,
            type: 'warning',
            confirmButtonText: 'Aceptar'
          })
          .then(()=>{
            return false;
          });
          
        }
        else{
          if(this.SMovimiento){
            if(this.file == undefined){
              this.$swal({
                title: 'Atención',
                text: 'Debe cargar el parte (plantilla excel).',
                type: 'warning',
                confirmButtonText: 'Aceptar'
              });
              return;
            }
            else{
              let fileName = this.file.name;
              var ext = fileName.split('.').pop();

              ext = ext.toLowerCase();
              if(ext != "xls" && ext != "xlsx"){
                this.$swal({
                  title: 'Atención',
                  text: 'Debe cargar el parte (plantilla excel).',
                  type: 'warning',
                  confirmButtonText: 'Aceptar'
                });
                return;
              }
            }

            let config = {        
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
            let formData = new FormData();
            formData.append('id_empresa', this.id_empresa);
            formData.append('archivo', this.file);
            formData.append('fecha_inicio', this.fechas.ayer);
            formData.append('fecha_fin', this.fechas.actual);

            let res = await this.axios.post(`/subir/partes_hospedaje`, formData, config);
            if (res.status === 200) {
              if(res.data.codigo === 0){
                this.$swal({
                  // title: 'Revice el archivo',
                  text: `Revice el archivo excel tiene ${res.data.contenido}`,
                  type: 'info',
                  confirmButtonText: 'Aceptar'
                });
                this.Limpiar();
              }
              else{
                this.cargarHistorial(this.id_empresa);
                this.$swal({
                  title: 'Información',
                  text: 'Se subió correctamente el archivo',
                  type: 'success',
                  confirmButtonText: 'Aceptar'
                });
                this.Limpiar();
              }
            }
          }
          else{
            let formData = new FormData();
            formData.append('id_empresa', this.id_empresa);
            formData.append('observacion', this.sin_movimiento);
            formData.append('fecha_inicio', this.fechas.ayer);
            formData.append('fecha_fin', this.fechas.actual);

            let res = await this.axios.post(`/subir/partes_hospedaje_sm`, formData);
            if (res.status === 200) {
              this.cargarHistorial(this.id_empresa);
              this.$swal({
                title: 'Información',
                text: 'Se subió correctamente el archivo',
                type: 'success',
                confirmButtonText: 'Aceptar'
              });
              //this.Limpiar();
              this.SMovimiento = true;
              this.sin_movimiento = '';
            }
          }
        }
      } catch (error) {
        console.log('catch: ', error);
        this.cargando = false;
      }
    },
    async cargarHistorial(id_empresa) {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/historial/partesHospesaje/${id_empresa}`);
        this.historial = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },
    async detallePartes(id_hotel) {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/historial/detalleHospedaje/${id_hotel}`);
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },
    async confirmar(item) {
      this.cargando = true;
      try {
        //console.log(item);
        let res = await this.axios.put(`/confirmarParteHospedaje/${item.id_hotel}`);
        if (res.status === 200) {
          this.cargando = false;
          this.cargarHistorial(this.id_empresa);
          this.hideModalConfirmar();
          this.$swal({
            title: 'Información',
            text: 'Finalizó correctamente el registro',
            type: 'success',
            confirmButtonText: 'Aceptar'
          });
        }
        
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },
    async downloadPlantilla(){
     try {
        let resultados = await this.axios.get('/getPlantillaHospedaje', {responseType: 'blob'});
        if(resultados.status == 200){
          let file = new Blob([resultados.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          FileSaver.saveAs(file, 'plantilla.xlsx');
        }
      } catch (error) {
        console.log('catch: ', error);
      }

    },
    onChangeFechaIni(event){
      let fecha = event.target._value;
      document.getElementById("fecha_fin").setAttribute("min",fecha);
    },
    onPopupAyuda(){
      this.$refs["modalAyuda"].show();
    },
    bajaParte(id_hotel){
      try {
        this.$swal({
          text: '¿Confirma quitar declaración?',
          type: 'warning',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Aceptar',
          showCancelButton: true,
          showCloseButton: true,
          showLoaderOnConfirm: true
        })
        .then((result)=>{
          if(result.value){
            this.axios.put(`/bajaParteHospedaje/${id_hotel}`)
            .then(()=>{
              this.cargarHistorial(this.empresa.id_empresa);
            });
          }
        });
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    Limpiar(){
      this.file = '';
      this.$refs.file.value = null;
    },
    async FechasHospedaje(){
      try {
        let res = await this.axios.get(`/fechasHospedaje`);
        let fecha = res.data.contenido;
        this.fechas.actual = fecha.actual;
        this.fechas.ayer = fecha.ayer;
      } catch (error) {
        console.log('cash: ', error);
      }
    },
    onChangeSinMovimiento(){
      if(this.sin_movimiento == "S/M"){
        this.SMovimiento = false;
      }
      else{
        this.SMovimiento = true;
      }
    },
    VerificaParte(){
      try {
        this.axios.get(`/verificaParteHospedaje/${this.id_empresa}/${this.fecha.actual}`);    
      } catch (error) {
         console.log('catch', error)
      }
    },
   
  },
  created(){
    //if(this.$route.params.id_empresa===undefined){
    if(this.$route.params.item===undefined){
      this.$router.push('Empresas');
    }else{
      //this.id_empresa = this.$route.params.id_empresa;
      this.empresa = this.$route.params.item;
      this.id_empresa = this.$route.params.item.id_empresa;
      this.cargarHistorial(this.empresa.id_empresa);
      this.FechasHospedaje();
    }   

  }

};
</script>
